import { render, staticRenderFns } from "./UserListConversations.vue?vue&type=template&id=2a93f4e9&"
import script from "./UserListConversations.vue?vue&type=script&lang=js&"
export * from "./UserListConversations.vue?vue&type=script&lang=js&"
import style0 from "./UserListConversations.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports